import React from 'react';
import { string, func, oneOfType, node, shape, bool } from 'prop-types';
import classNames from 'classnames/bind';
import style from './Button.module.scss';

const cx = classNames.bind(style);

const Button = ({
  className,
  onClick,
  children,
  title,
  disabled,
  qaTag,
  type,
}) => (
  <button
    className={cx('button', className)}
    {...(qaTag && { 'data-qa': qaTag })}
    type={type}
    aria-label={title}
    disabled={disabled}
    {...(onClick && { onClick })}
  >
    {children}
  </button>
);

Button.propTypes = {
  className: string,
  onClick: func,
  children: oneOfType([string, node, shape]).isRequired,
  title: string.isRequired,
  disabled: bool,
  qaTag: string,
  type: string,
};

Button.defaultProps = {
  className: null,
  onClick: null,
  disabled: false,
  qaTag: null,
  type: 'button',
};

export { Button };
